/* Dr.Primal — capture step: pick three cards (the second game).

   A grid of face-down cards, each a real <button>, so a tap, a click, Enter or Space all
   turn one. Each card turns alone to show the offer and is then spent (aria-disabled,
   still focusable, still announced); the rest stay face down. When PICKS_REQUIRED cards
   are up, the step moves straight on (owner decision: no check marks, no matched line):
   after REVEAL_HOLD_MS, just long enough for the third card to finish turning, `mount()`
   resolves `{ revealed: 'card', picks: [indexes] }` (0-based,
   in the order picked).

   Honest framing (UK CAP rules: nothing may suggest chance): every card holds the same
   offer, so the section's copy never says win, luck or prize.

   How many cards there are is the section's decision (its `dp_capture_card_count`); this
   file turns whatever cards it finds. The flip is CSS (a 3D rotateY on the class below);
   under reduced motion the section drops the transition, so cards turn at once and there
   is no hold. Each card's face is text Liquid wrote, copied into the polite status line. No
   user-facing English here. */
(function () {
  'use strict';

  var PICKS_REQUIRED = 3;                       // cards the visitor turns before the offer is theirs; the section's copy says "three", so change both together
  var REVEAL_HOLD_MS = 600;                     // lets the third card finish turning (--duration-slower is 480ms) before the email step; 0 under reduced motion
  var OPEN_CLASS = 'dp-capture__flip--open';    // turns a card face up; the rotation lives in the section CSS
  // Markup hooks. Each must match sections/dp-capture.liquid.
  var CARD_SELECTOR = '[data-dp-capture-card-button]';
  var FACE_SELECTOR = '[data-dp-capture-card-face]';
  var ANNOUNCE_SELECTOR = '[data-dp-capture-announce]';

  var capture = window.dpCapture;
  if (!capture) {
    console.error('[dp-capture-step-cards] dp-capture.js must load before this file');
    return;
  }

  function textOf(node) {
    return (node ? node.textContent : '').replace(/\s+/g, ' ').trim();
  }

  function cardsStep(root, ctx) {
    var cards = Array.prototype.slice.call(root.querySelectorAll(CARD_SELECTOR));
    var announce = root.querySelector(ANNOUNCE_SELECTOR);
    var picks = [];
    var timers = [];
    var listeners = [];

    function on(target, type, handler) {
      target.addEventListener(type, handler);
      listeners.push([target, type, handler]);
    }

    return {
      mount: function () {
        return new Promise(function (resolve) {
          cards.forEach(function (card, index) {
            on(card, 'click', function () {
              if (picks.length >= PICKS_REQUIRED || picks.indexOf(index) !== -1) return;
              picks.push(index);
              card.classList.add(OPEN_CLASS);
              // aria-disabled, not disabled: the card keeps focus and is still announced.
              card.setAttribute('aria-disabled', 'true');
              announce.textContent = textOf(card.querySelector(FACE_SELECTOR));
              if (picks.length < PICKS_REQUIRED) return;

              var chosen = picks.slice();
              timers.push(
                window.setTimeout(function () {
                  resolve({ revealed: 'card', picks: chosen });
                }, ctx.reducedMotion ? 0 : REVEAL_HOLD_MS)
              );
            });
          });
        });
      },
      unmount: function () {
        timers.forEach(function (timer) {
          window.clearTimeout(timer);
        });
        timers = [];
        listeners.forEach(function (entry) {
          entry[0].removeEventListener(entry[1], entry[2]);
        });
        listeners = [];
      },
    };
  }

  // Constants the tests read. The theme never calls these directly.
  cardsStep.core = { PICKS_REQUIRED: PICKS_REQUIRED, REVEAL_HOLD_MS: REVEAL_HOLD_MS };

  capture.registerStep('cards', cardsStep, { game: true });
})();
